import { useTranslation } from "react-i18next";
import Meta from "services/Meta";
import ForgetPass from "./ForgetPass";
import { useState } from "react";
import OTP from "./OTP";
import ResetPassword from "./ResetPassword";
import useScrollTop from "hooks/v2/useScrollTop";

const ForgetPassword = () => {
  const { t } = useTranslation();
  let [page, setPage] = useState(1);
  const [data, setData] = useState({});
  useScrollTop(page);

  const handlePage = () => {
    switch (page) {
      case 1:
        return <ForgetPass setPage={setPage} setData={setData} />;
      case 2:
        return <OTP setPage={setPage} setData={setData} data={data} />;
      case 3:
        return <ResetPassword data={data} />;
      default:
        break;
    }
  };

  return (
    <>
      <Meta title={t("pages.login")} />
      {handlePage()}
    </>
  );
};

export default ForgetPassword;
